export default __webpack_public_path__ + "static/media/victorops.3ec7e20f92b67b587ad122a560928c60.svg";